<template>
    <Modal v-model="planExportByDateModel.show" title="请选择要导出的周期" :mask-closable="false"
        :loading="true" footer-hide width=600>
        <Form  :label-width="80">
                <Row :gutter="16">
                <Col span="10" offset="1">
                <FormItem label="开始年份">
                    <Select v-model="planExportByDateModel.beginYear">
                        <Option v-for="item in planExportByDateBeginYearList" :value="item" :key="item">{{ item }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="10">
                <FormItem label="开始周数">
                    <Select v-model="planExportByDateModel.beginWeek">
                        <Option v-for="item in planExportByDateBeginWeekList" :value="item" :key="item">{{ item }}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row> 
            <Row :gutter="16">
                <Col span="10"  offset="1">
                <FormItem label="结束年份">
                    <Select v-model="planExportByDateModel.endYear">
                        <Option v-for="item in planExportByDateEndYearList" :value="item" :key="item">{{ item }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="10">
                <FormItem label="结束周数">
                    <Select v-model="planExportByDateModel.endWeek">
                        <Option v-for="item in planExportByDateEndWeekList" :value="item" :key="item">{{ item }}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row> 
            <Row>
            <Col  span="4" offset="16">
            <Button type="info"  class="btns" shape="circle" icon="ios-send"
                    @click="onExportByDateRange()">确认导出</Button>
            </Col>
            </Row>
        </Form>
	
	</Modal>
</template>
<script>
import { 
    getMyPreSalePlanByDateRange,
    importPreSalePlan
} from '@/api/modules/preSale-management/preSale-plan';
import {
    DOWNLOAD_SERVER,
    FILE_SERVER,
    UPLOAD_FILE_API
} from '@/api/modules/files';
export default {
    name: 'ExcelExportByDaterange',
    data() {
        return {
            planExportByDateModel: {
                show: false,
                beginYear:'',
                beginWeek:'',
                endYear:'',
                endWeek:'',
                yearList:[],
                yearWeekList:[]		
            },
            planExportByDateBeginYearList:[],
            planExportByDateBeginWeekList:[],
            planExportByDateEndYearList:[],
            planExportByDateEndWeekList:[],
            tableSearch:[]
        };
    },

    methods: {
        showModal(beginYear, beginWeek, endYear, endWeek, yearList, yearWeekList, beginYearoption, beginWeekList, endYearOption, endWeekList, tableSearch) {
            this.planExportByDateModel.show = true;
            this.planExportByDateModel.beginYear = beginYear;
            this.planExportByDateModel.beginWeek = beginWeek;
            this.planExportByDateModel.endYear = endYear;
            this.planExportByDateModel.endWeek = endWeek;
            this.planExportByDateModel.yearList = yearList;
            this.planExportByDateModel.yearWeekList = yearWeekList;
            this.planExportByDateBeginYearList = beginYearoption;
            this.planExportByDateBeginWeekList = beginWeekList;
            this.planExportByDateEndYearList = endYearOption;
            this.planExportByDateEndWeekList = endWeekList;
            this.tableSearch = tableSearch;
        },
        onImportPlan() {
            importPreSalePlan({
                importFileName: this.planImportModel.fileWebName
            }).then(res => {
                this.planImportModel.show = false;
                if (res.code === 0) {
                    this.getPlanWeeks();
                    this.$Modal.success({
                        title: '导入成功',
                        content: ''
                    });
                }
            });
        },
        onExportByDateRange() {
				    let beginYear= this.planExportByDateModel.beginYear;
            let beginWeek=this.planExportByDateModel.beginWeek;
            let endYear=this.planExportByDateModel.endYear;
            let endWeek= this.planExportByDateModel.endWeek;
            if(beginYear*100+beginWeek>endYear*100+endWeek){
                this.$Message.error('开始周期不能大于结束周期');
                return;
			     }
            const queryData = Object.assign(this.tableSearch, {
                beginYear,
                beginWeek,
                endYear,
                endWeek,
                seedFarmUuid: this.selectedSeedFarmUuid,			
                needExport: true
            });
            this.tableSearch.limit.enable = false;
            getMyPreSalePlanByDateRange(queryData).then(res => {
                this.planExportByDateModel.show=false;
                if (res.code === 0) {
                    window.open(DOWNLOAD_SERVER + res.data.exportFileName, "_blank");
                }
            }).catch(() => {
                this.planExportByDateModel.show=false;
            });
        }
    }
};
</script>